import React from "react";
import { useTranslation } from "react-i18next";

interface GamingFooterProps {
  showFooter?: boolean;
  variant?: "dark" | "light" | "gradient";
}

const GamingFooter: React.FC<GamingFooterProps> = ({
  showFooter = true,
  variant = "dark",
}) => {
  const { t } = useTranslation("clientView");

  if (!showFooter) return null;

  const getVariantStyles = () => {
    switch (variant) {
      case "light":
        return {
          container: "px-4 py-3 border-t border-gray-200 bg-white/90",
          text: "text-gray-500",
          link: "font-semibold text-purple-600 hover:text-purple-700 transition-colors",
        };
      case "gradient":
        return {
          container:
            "px-4 py-3 border-t border-purple-500/30 bg-gradient-to-r from-purple-900/50 to-purple-900/50",
          text: "text-purple-300",
          link: "font-semibold text-purple-400 hover:text-purple-300 transition-colors",
        };
      case "dark":
      default:
        return {
          container: "px-4 py-3 border-t border-gray-700 bg-gray-900/50",
          text: "text-gray-500",
          link: "font-semibold text-blue-600 hover:text-blue-700 transition-colors",
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div className={`w-full ${styles.container}`}>
      <p className="text-[10px] text-center" dir="auto">
        <bdi>
          <span className={styles.text}>{t("games.footer.poweredBy")} </span>
          <a
            href="https://super-user-manager.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            Super User Manager
          </a>
        </bdi>
      </p>
    </div>
  );
};

export default GamingFooter;
